<div class="full-width full-height" [ngClass]="{'bms-theme': canShowBMSTheme, 'p-24': canShowBMSTheme}">
  <ng-container #contentSwitcherContainer />
</div>
